import React from "react";
import flower from "assets/icons/flower.svg";

export const PaidLandingHeroContent = {
    control: {
        heading: "Find the Cheapest Storage Units Near You",
        description:
            "Search and compare more storage locations and units than any other storage site.",
        bottomText: {
            start: "Over 97% of Reviewers Have Given Us a ",
            middle: "4 out of 5 Star Rating or Higher ",
            end: "on Trustpilot!"
        }
    },
    variation1: {
        pillText: "Spring Savings! Save Up to 25% Today",
        heading: "Find the Cheapest Storage Units Near You",
        description:
            "Search and compare more storage locations and units than any other storage site.",
        bottomText: {
            start: "Over 97% of Reviewers Have Given Us a ",
            middle: "4 out of 5 Star Rating or Higher ",
            end: "on Trustpilot!"
        }
    },
    variation2: {
        pillText: (
            <div>
                <img
                    src={flower}
                    alt="flower icon"
                    className="flower-icon"
                />
                Spring Savings!
            </div>
        ),
        heading: "Up to 25% off selected units",
        description: "Compare prices across 10,000 + units",
        bottomText: {
            start: "Over 97% of Reviewers Have Given Us a ",
            middle: "4 out of 5 Star Rating or Higher ",
            end: "on Trustpilot!"
        }
    }
};